var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{attrs:{"app":""}},[_c('navigationDrawer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }